import { useEffect, useRef, useState } from 'react';
import * as PIXI from 'pixi.js';
import AssetsLoader from '../../features/gameplay/utils/assetsLoader';
import { useApi } from '../../services/api/ApiProvider';

import CardContainer from '../../features/gameplay/containers/cardContainer';
import { CARD_HEIGHT, CARD_WIDTH } from '../../features/gameplay/utils/commonUtils';

const leaderCardInstance = {
    "instanceId": "inst_1746715844767_zumea",
    "baseCardId": "ST01-001",
    "ownerPlayerId": "KIJFvN51oev_AjZbAAAH",
    "isRested": false,
    "attachedDon": [],
    "currentPower": 5000,
    "location": "Leader",
    "turnPlayed": -1,
    "baseData": {
        "id": "ST01-001",
        "alternateArts": [],
        "name": "Monkey.D.Luffy",
        "type": "Leader",
        "attribute": "Strike",
        "effectText": "[Activate: Main] [Once Per Turn] Give this Leader or 1 of your Characters up to 1 rested DON!! card.",
        "imgUrl": "https://en.onepiece-cardgame.com/images/cardlist/card/ST01-001.png?230630",
        "power": 5000,
        "cost": null,
        "life": 5,
        "counter": null,
        "color": [
            "Red"
        ],
        "cardTraits": [
            "Supernovas",
            "Straw Hat Crew"
        ],
        "rarity": "L"
    },
    "detailedEffects": [
        {
            "trigger": "ActivateMain",
            "restriction": "OncePerTurn",
            "description": "[Activate: Main] [Once Per Turn] Give this Leader or 1 of your Characters up to 1 rested DON!! card.",
            "preConditions": [
                {
                    "check": "hasRestedDon",
                    "zone": "CostArea",
                    "count": 1
                }
            ],
            "version": 2,
            "effectSteps": [
                {
                    "stepId": "chooseRecipient",
                    "type": "target",
                    "targetCriteria": {
                        "scope": "Player",
                        "zone": [
                            "Leader",
                            "FieldCharacters"
                        ],
                        "maxTargets": 1,
                        "optional": false,
                        "filters": []
                    }
                },
                {
                    "stepId": "action",
                    "type": "action",
                    "actionType": "AttachDonV2",
                    "details": {
                        "targetCardStepIdRef": "chooseRecipient",
                        "isRested": true,
                        "count": 1
                    }
                }
            ],
            "targetSteps": [
                {
                    "stepId": "chooseRecipient",
                    "scope": "Player",
                    "zone": [
                        "Leader",
                        "FieldCharacters"
                    ],
                    "maxTargets": 1,
                    "optional": false,
                    "filters": [],
                    "prompt": "Choose Leader or Character to receive DON!!"
                },
                {
                    "stepId": "chooseDon",
                    "scope": "Player",
                    "zone": "CostArea",
                    "maxTargets": 1,
                    "optional": true,
                    "filters": [
                        {
                            "field": "isRested",
                            "comparison": "eq",
                            "value": true
                        }
                    ],
                    "prompt": "Choose 1 Rested DON!! from your Cost Area"
                }
            ],
            "action": {
                "type": "AttachDon",
                "details": {
                    "donInstanceIdRef": "chooseDon",
                    "targetCardIdRef": "chooseRecipient"
                }
            }
        }
    ],
    "name": "Monkey.D.Luffy",
    "type": "Leader",
    "cost": null,
    "power": 5000,
    "life": 5,
    "counter": null,
    "attribute": "Strike",
    "color": [
        "Red"
    ],
    "cardTraits": [
        "Supernovas",
        "Straw Hat Crew"
    ],
    "effectText": "[Activate: Main] [Once Per Turn] Give this Leader or 1 of your Characters up to 1 rested DON!! card.",
    "imgUrl": "https://en.onepiece-cardgame.com/images/cardlist/card/ST01-001.png?230630",
    "hasRush": false
};

export default function ShadersDemoPage() {
    const pixiContainerRef = useRef(null);
    const pixiAppRef = useRef(null);

    const api = useApi();


    useEffect(() => {
        const initGame = async () => {
            if (!pixiAppRef.current && pixiContainerRef.current) {
                await Promise.all([...(await document.fonts.ready)].map(font => font.load()));

                const app = new PIXI.Application();
                await app.init({
                    width: 800,
                    height: 600,
                    backgroundColor: 0x1099bb,
                    antialias: true,
                });

                await AssetsLoader.init();

                const deckAssets1 = await api.fetchDeckAssets('ST01');
                // const deckAssets2 = await api.fetchDeckAssets('ST04');

                await AssetsLoader.loadDecks([deckAssets1]);

                pixiAppRef.current = app;
                window.globalThis.__PIXI_APP__ = app;

                pixiContainerRef.current.appendChild(app.canvas);

                const going_merry_texture = await PIXI.Assets.load('/assets/going_marry.png');
                const going_merry_sprite = new PIXI.Sprite(going_merry_texture);
                going_merry_sprite.anchor.set(0.5);
                going_merry_sprite.x = 400;
                going_merry_sprite.y = 582.5;
                going_merry_sprite.scale.set(1.1);
                app.stage.addChild(going_merry_sprite);

                const cardContainer = new CardContainer(leaderCardInstance);
                cardContainer.label = 'cardContainer';
                cardContainer.x = 400;
                cardContainer.y = 427;
                cardContainer.scale.set(0.9);
                app.stage.addChild(cardContainer);

                const particleContainer = new PIXI.ParticleContainer();
                particleContainer.x = 400;
                particleContainer.y = 427 - (CARD_HEIGHT*0.9)/2;
                const particleCircle = PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.PARTICLE_CIRCLE);
                const particle = new PIXI.Particle({ texture: particleCircle, anchorX: 0.5, anchorY: 0.5, tint: '#ff0000' });
                particleContainer.addParticle(particle);
                app.stage.addChild(particleContainer);

                app.stage.scale.set(0.55);
            }
        }
        initGame();

        return () => {
            if (pixiAppRef.current) {
                pixiAppRef.current.destroy(true, { children: true, texture: true, baseTexture: true });
                pixiAppRef.current = null;
            }
        }
    }, []);

    return (
        <div>
            <h1>Particles Demo</h1>
            <div ref={pixiContainerRef} />
        </div>
    );
}
